import { BaseRepository } from "../../../../infrastructure/BaseRepository";
import authClaimsResource from "../resources/AuthClaimsResource";

class AuthClaimsRepository extends BaseRepository {
  constructor() {
    super(authClaimsResource)
  }

  
  public checkHeaders() {
    return this.resource('check_headers')
      .get().then((res) => this.processResponse(res));
  }
}

const authClaimsRepository = new AuthClaimsRepository();

export default authClaimsRepository; 